import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, Ref } from 'vue';
import IconButton from '../common/base/IconButton.vue';
import TUIMessageBox from '../common/base/MessageBox/index';
import SvgIcon from '../common/base/SvgIcon.vue';
import CameraOnIcon from '../common/icons/CameraOnIcon.vue';
import CameraOffIcon from '../common/icons/CameraOffIcon.vue';
import VideoSettingTab from '../common/VideoSettingTab.vue';
import { useI18n } from '../../locales';
import '../../directives/vClickOutside';
import { isGetUserMediaSupported, isEnumerateDevicesSupported } from '../../utils/mediaAbility';

interface Props {
  hasMore?: boolean,
  isMuted: boolean,
  isDisabled?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoMediaControl',
  props: {
    hasMore: { type: Boolean, default: true },
    isMuted: { type: Boolean, default: undefined },
    isDisabled: { type: Boolean, default: false }
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {

const props = __props as { hasMore: boolean, isMuted: boolean, isDisabled: boolean }





const { t } = useI18n();
const showVideoSettingTab: Ref<boolean> = ref(false);
const isSupportVideoMedia = isGetUserMediaSupported && isEnumerateDevicesSupported;

const icon = computed(() => (props.isMuted ? CameraOffIcon : CameraOnIcon));

async function handleClickIcon() {
  if (!isSupportVideoMedia) {
    TUIMessageBox({
      title: t('Note'),
      message: t('The current browser does not support capturing video'),
      appendToRoomContainer: true,
      confirmButtonText: t('Sure'),
    });
    return;
  }
  emits('click');
  showVideoSettingTab.value = false;
}

function handleMore() {
  showVideoSettingTab.value = !showVideoSettingTab.value;
}

function handleHideVideoSettingTab() {
  if (showVideoSettingTab.value) {
    showVideoSettingTab.value = false;
  }
}


return { __sfc: true,props, emits, t, showVideoSettingTab, isSupportVideoMedia, icon, handleClickIcon, handleMore, handleHideVideoSettingTab, IconButton, SvgIcon, VideoSettingTab }
}

})